<template>
  <div>
    <Header title="系統設置" @rightClick="onSave" />
    <div>
      <div class="main" v-if="obj">
        <!-- {{ obj }} -->
        <h3>商店設定</h3>
        <Input :r="obj.storeName" />
        <ImagePicker :r="obj.storeImg" />
        <InputArea :r="obj.storeNote" />
        <van-divider />

        <h3>歡迎畫面 (圖片建議尺寸:手機直立.寬:414x高:896)</h3>
        <van-row>
          <van-col span="8"><ImagePicker :r="obj.welcome1" /></van-col>
          <van-col span="8"><ImagePicker :r="obj.welcome2" /></van-col>
          <van-col span="8"><ImagePicker :r="obj.welcome3" /></van-col>
        </van-row>

        <van-divider />
        <h3>風格</h3>
        <ColorPicker :r="obj.color1" />
        <ColorPicker :r="obj.color2" />
        <ColorPicker :r="obj.color3" />
        <RadioGroup :cols="[1, 2, 3, 4, 5]" :r="obj.menuLineN" />
        <RadioGroup :cols="['平整', '圓角']" :r="obj.btnRadius" />
        <RadioGroup :cols="['平整', '圓角', '正圓']" :r="obj.imgRadius" />

        <van-divider />

        <van-row>
          <van-col span="12"><h3>參數設定</h3></van-col>
          <van-col span="12"><MpoTip /></van-col>
        </van-row>
        <CheckBox :r="obj.calcService" />
        <CheckBox :r="obj.serviceRate07" />
        <CheckBox :r="obj.noStepper" />
        <CheckBox :r="obj.userNote" />
        <CheckBox :r="obj.bell" />
        <CheckBox :r="obj.noPhoneIuput" />
        <CheckBox :r="obj.printpo_by_area" />
        <CheckBox :r="obj.chkHideCheckWhenAmt0" />
        <CheckBox :r="obj.chkForbidNoPassCode" />
        <CheckBox :r="obj.chkIndexTopBell" />
        <CheckBox :r="obj.chkEditGroupTime" />
        <CheckBox :r="obj.chkMenuFontSizeLarge" />

        <van-divider />
        <Input :r="obj.maxItemQty" />
        <Input :r="obj.sendOkMsg" />
        <Input :r="obj.cSendTime" />
        <Input :r="obj.maxQty" />
        <Input :r="obj.bellType" />
        <Input :r="obj.MaxOrderTime" disabled />
        <van-divider />
        <h3>KIOSK設定</h3>
        <CheckBox :r="obj.kioskMode" />

        <van-divider />
        <h3>客製化項目</h3>
        <CheckBox :r="obj.chkCartNoSumAmt" />

        <van-divider />
        <h3>吃到飽設定</h3>
        <CheckBox :r="obj.chkBuffet" />
        <div v-if="obj.chkBuffet.value">
          <CheckBox :r="obj.chkShowTimeTip" />
          <CheckBox :r="obj.chkCarHide0Price" />
          <CheckBox :r="obj.chkButtonLargeText" />
          <CheckBox :r="obj.chkCheckItemMaxQty" />

          <!-- <Input :r="obj.txtBuffetMin" /> -->
          <van-button icon="plus" @click="addBuffetS1">新增人頭菜單設定</van-button>
          <div v-for="(r, index) in obj.buffetS1" :key="'A' + index">
            <el-card>
              <div slot="header" class="clearfix">
                <span># {{ index + 1 }} : {{ r.itemname }}</span>
                <el-button
                  style="float: right; padding: 3px 0"
                  type="text"
                  @click="obj.buffetS1.splice(index, 1)"
                  >刪除</el-button
                >
              </div>
              <div>人頭項目</div>
              <el-select
                v-model="r.itemname"
                filterable
                default-first-option
                placeholder="請選擇"
              >
                <el-option
                  v-for="item in menuitem"
                  :key="item.TypeNo + item.ItemName"
                  :label="item.ItemName + ' $' + item.Price1"
                  :value="item.ItemName"
                >
                </el-option>
              </el-select>

              <div style="margin-bottom: 1rem">
                <div>可選類別</div>
                <el-select
                  v-model="r.typelist"
                  multiple
                  filterable
                  default-first-option
                  placeholder="請選擇"
                  style="width: 100%"
                >
                  <el-option v-for="t in exttype" :key="t.id" :label="t.id" :value="t.id">
                  </el-option>
                </el-select>
              </div>
            </el-card>
          </div>
        </div>
      </div>
      <!-- <div class="main" v-for="n in 40" :key="n">{{ n }}</div> -->
    </div>
  </div>
</template>
<style scoped>
.main {
  text-align: left;
  padding: 1rem;
  line-height: 2rem;
  overflow-y: scroll;
}
.el-card {
  margin-top: 1rem;
  line-height: 2.4rem;
}
.van-button {
  width: 100%;
}
</style>
<script>
import Header from "@/components/Config/ConfigHeader.vue";
import MpoTip from "./elements/MpoTip.vue";
export default {
  // components: { Header },
  components: { Header, MpoTip },
  data() {
    return {
      parentData: "pd",
      obj: null,
      exttype: null,
      menuitem: null,
      def: {
        welcome1: {
          label: "輪播圖1",
          value: "",
          remark: "",
        },
        welcome2: {
          label: "輪播圖2",
          value: "",
          remark: "",
        },
        welcome3: {
          label: "輪播圖3",
          value: "",
          remark: "",
        },
        storeName: {
          label: "餐廳名稱",
          value: "",
          remark: "",
        },
        storeImg: {
          label: "餐廳海報",
          value: "",
          remark: "",
        },
        storeNote: {
          label: "餐廳文字資訊",
          value: "",
          remark: "商店介紹、營業時間、點餐需知...",
        },
        calcService: {
          label: "加上服務費(預設1成)",
          value: false,
          remark: "",
        },
        noStepper: {
          label: "不顯示加減號按鈕 (1份1份點選...)",
          value: false,
          remark: "",
        },
        color1: {
          label: "數字顏色",
          value: "#F49B0B",
          remark: "",
        },
        color2: {
          label: "控制項顏色",
          value: "#0D97ED",
          remark: "",
        },
        color3: {
          label: "按鈕顏色",
          value: "#333333",
          remark: "",
        },
        userNote: {
          label: "允許客戶自訂口味",
          value: false,
          remark: "",
        },
        maxItemQty: {
          label: "加入購物車時數量(上限)",
          value: 9,
          remark: "",
        },
        sendOkMsg: {
          label: "傳送成功訊息",
          value: "您的餐點已傳送成功",
          remark: "",
        },
        bellType: {
          label: "服務鈴種類(半型逗號間隔),例:補茶水,補餐具,買單",
          value: "",
          remark: "",
        },
        bell: {
          label: "啟用服務鈴",
          value: false,
          remark: "",
        },
        cSendTime: {
          label: "傳送隔時間(分鐘)",
          value: 0,
          text: "",
        },
        maxQty: {
          label: "購物車.合計數量上限",
          value: 30,
          remark: "",
        },
        menuLineN: {
          label: "每行顯示餐點數量",
          value: 1,
          remark: "",
        },
        imgRadius: {
          label: "餐點圖片",
          value: "平整",
          remark: "",
        },
        btnRadius: {
          label: "按鈕",
          value: "平整",
          remark: "",
        },
        noPhoneIuput: {
          label: "不顯示電話輸入",
          value: false,
          remark: "",
        },
        kioskMode: {
          label: "kiosk模式(不顯示之前訂單/上方類別放大/關閉'內用'模式)",
          value: false,
          remark: "",
        },
        chkBuffet: {
          label: "吃到飽模式",
          value: false,
          remark: "",
        },
        // txtBuffetMin: {  //廢除：因bnserv已經用MaxOrderTime,
        //   label: "可點分鐘(例:90表示1個半小時)",
        //   value: 90,
        //   remark: "",
        // },
        buffetS1: [],
        chkCartNoSumAmt: {
          label: "加入項目及購物車合計'按鈕'不顯示金額",
          value: false,
          remark: "",
        },
        // txtMaxItemQty: {
        //   label: "加入項目數量上限 (例:1 ,即表示1次點1份)",
        //   value: 1,
        //   remark: "",
        // },
      },
      options: [],
    };
  },
  async mounted() {
    await this.init();
  },
  methods: {
    async init() {
      try {
        var res = await this.apiGetBKMenu();
        console.log("res", res);
        var config = res.data.config;
        Object.keys(this.def).forEach((r) => {
          if (!Object.hasOwn(config, r)) {
            //如果舊資料確少欄位，補上
            config[r] = this.def[r];
          }
        });

        this.exttype = res.data.exttype;
        this.menuitem = res.data.menuitem;
        this.obj = config;
      } catch (error) {
        console.log(error.toString());
      }
    },
    async onSave() {
      try {
        var body = this.obj;
        var res = await this.apiSaveConfig(body);
        console.log("res", res);
        this.gMsgbox("儲存完成").then(() => {
          this.$router.push("/");
        });
      } catch (error) {
        console.log(error.toString());
      }
    },
    async addBuffetS1() {
      try {
        let row = { itemname: "", typelist: [] };
        // if (!this.obj.buffetS1) this.obj.buffetS1 = [];
        this.obj.buffetS1.push(row);

        // var body = this.obj;
        // var res = await this.apiSaveConfig(body);
        // console.log("res", res);
        // this.gMsgbox("儲存完成").then(() => {
        //   this.$router.push("/");
        // });
      } catch (error) {
        console.log(error.toString());
      }
    },
    addOptions() {
      this.options.forEach((r) => {
        // let row = {};
        // r = JSON.parse(r);
        // row.TypeNo = r.TypeNo;
        // row.ItemName = r.ItemName;
        // row.KPtype = r.KPtype;
        // row.ItemCode = r.ItemCode;
        // row.Price1 = r.Price1;

        this.obj.groups.push(r);
      });
      this.options = [];
    },
  },
};
</script>
